export enum VehicleType {
    Car = 0,
    Van = 1,
    Freighter = 2,
}